import { Component, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { AkitaScreenQuery } from '@app/akita/screen/state/screen.query';
import { ScreenSizeInfoState } from '@app/akita/screen/state/screen.store';
import { AkitaRouterQuery } from '@app/akita/router/state/router.query';
import { FooterComponent } from '../shared/components/new-footer/footer.component';
import { EasyReturnsIconComponent } from '../shared/components/icons/generated/easy-returns/easy-returns.component';
import { CertifiedRibbon1IconComponent } from '../shared/components/icons/generated/certified-ribbon-1/certified-ribbon-1.component';
import { WarrantyIconIconComponent } from '../shared/components/icons/generated/warranty-icon/warranty-icon.component';
import { NgIf, AsyncPipe } from '@angular/common';
import { TranslocoModule } from '@ngneat/transloco';

@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.template.html',
  styleUrls: ['./about-us.style.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TranslocoModule,
    NgIf,
    WarrantyIconIconComponent,
    CertifiedRibbon1IconComponent,
    EasyReturnsIconComponent,
    FooterComponent,
    AsyncPipe,
  ],
})
export class AboutUsComponent implements OnDestroy {
  public isBrowser: boolean;

  public lessThan$: Observable<ScreenSizeInfoState>;
  public inFullScreenMode$: Observable<boolean>;

  private readonly destroySubject: Subject<void>;

  constructor(
    private readonly akitaScreenQuery: AkitaScreenQuery,
    private readonly akitaRouterQuery: AkitaRouterQuery
  ) {
    this.destroySubject = new Subject();
    this.isBrowser = this.akitaRouterQuery.isBrowser;
    this.lessThan$ = this.akitaScreenQuery.selectLessThan();
    this.inFullScreenMode$ = this.akitaRouterQuery.selectInFullScreenMode();
  }

  public ngOnDestroy(): void {
    this.destroySubject.next();
    this.destroySubject.complete();
  }
}
